export const MENU_LANGUAGE = {
  menu_sidebar_dashboard: "Dashboard",
  menu_sidebar_takaful_provider: "Takaful Provider",
  menu_sidebar_partner: "Partner Management",
  menu_sidebar_partner_b2b2c: "B2B2C",
  menu_sidebar_partner_b2b2c_listing: "Partner User",
  menu_sidebar_partner_b2b: "B2B",
  menu_sidebar_partner_incentive_management: "Incentive Management",
  menu_sidebar_partner_encashment_request: "Encashment Request",
  menu_sidebar_partner_b2b_router: "Partner Management / B2B",
  menu_sidebar_takaful_bazaar_partner: "Takaful Bazaar Partners",
  menu_sidebar_service_provider: "Service Provider",
  menu_sidebar_management: "Management",
  menu_sidebar_management_user: "User Management",
  menu_sidebar_management_blogs: "Blogs",
  management_blogs: "Blogs",
  menu_sidebar_reports: "Reports",
  menu_sidebar_reports_finance: "Finance",
  menu_sidebar_management_roles: "Role Management",
  menu_sidebar_coupon: "Coupons",
  menu_sidebar_management_service: "Service Facility",
  menu_sidebar_management_service_hospital: "Hospitals",
  menu_sidebar_management_list_management: "List Management",
  menu_sidebar_management_list_management_groups: "Groups",
  menu_sidebar_management_list_management_groups_hospital: "Hospitals",
  menu_sidebar_management_list_management_groups_discount_center: "Discount Centers",
  menu_sidebar_management_list_management_groups_cash_less_workshop: "Cashless Workshop",
  menu_sidebar_management_services: "Services",
  menu_sidebar_management_list_management_coverages: "Coverages",
  menu_sidebar_management_list_management_make: "Make",
  menu_sidebar_management_list_management_model: "Model",
  menu_sidebar_management_list_management_variant: "Variant",
  menu_sidebar_management_list_management_assembly: "Assembly",
  menu_sidebar_management_exclusion: "Exclusions",
  menu_sidebar_management_region: "Region/Province",
  menu_sidebar_management_tax_and_admin: "Tax & Admin",
  menu_sidebar_management_tax_and_admin_taxation: "Taxation",
  menu_sidebar_management_tax_and_admin_payment_method: "Payment Method",
  menu_sidebar_management_tax_and_admin_admin: "Admin Expense",
  menu_sidebar_management_tax_and_admin_payment_gateway: "Payment Gateway",
  menu_sidebar_management_tax_and_admin_transaction_cost: "Transaction Cost",
  menu_sidebar_management_sale_point: "Sale Point",
  menu_sidebar_management_user_roles: "Roles & Permissions",
  menu_sidebar_management_add_permission: "Add Permission",
  menu_sidebar_management_user_tbuser: "Add User",
  menu_sidebar_management_user_team_management: "Takaful Bazaar User",
  menu_sidebar_management_user_partner_user: "Partner B2B2C User",
  menu_sidebar_management_user_partner_b2b_user: "Partner B2B User",
  menu_sidebar_management_rules: "Role Management",
  menu_sidebar_management_features: "Features",
  menu_sidebar_health: "Health",
  menu_sidebar_personal_accident: "Personal Accident",
  menu_sidebar_travel: "Travel",
  menu_sidebar_house_hold: "Household",
  menu_sidebar_life: "Life",
  menu_sidebar_health_plan_setup: "Plan Setup",
  menu_sidebar_health_plan_setup_b2b: "B2B",
  menu_sidebar_health_plan_setup_plans: "Plans",
  menu_sidebar_family_plan_setup: "Plan Setup",
  menu_sidebar_family_plan_setup_b2b: "B2B",
  menu_sidebar_family_plan_setup_plans: "Plans",
  menu_sidebar_health_plan_setup_b2c: "B2C",
  menu_sidebar_health_plan_setup_b2c_shelf_plans: "Shelf Plans",
  menu_sidebar_health_plan_setup_b2c_customized_plans: "Customized Plans",
  menu_sidebar_management_service_discount_center: "Discount Center",
  menu_sidebar_management_service_cash_less_workshop: "Cashless Workshop",
  menu_sidebar_manage_faq: "FAQs",
  menu_sidebar_lead_view: "Leads",
  menu_sidebar_leads_auto: "Auto",
  menu_sidebar_leads_health: "Health",
  menu_sidebar_leads_travel: "Travel",
  menu_sidebar_leads_life: "Life",
  menu_sidebar_health_orders: "Orders",
  menu_sidebar_health_abandoned_checkouts: "Abandoned checkouts",
  menu_sidebar_management_list_management_plan_type: "Plan Type",
  menu_sidebar_auto: "Auto",
  menu_sidebar_family: "Family",
  menu_sidebar_auto_plan_setup: "Plan Setup",
  menu_sidebar_auto_plan_setup_b2c: "B2C",
  menu_sidebar_auto_plan_setup_b2b2c: "B2B2C",
  menu_sidebar_auto_plan_setup_b2b2c_shelf_plans: "Shelf Plans",
  menu_sidebar_auto_plan_setup_b2c_shelf_plans: "Shelf Plans",
  menu_sidebar_takaful_bazaar_partner_premises: "Premises",
  menu_sidebar_auto_plan_setup_b2b: "B2B",
  menu_sidebar_auto_plan_setup_plans: "Plans",
  menu_sidebar_auto_orders: "Orders"
};
